module.exports = __webpack_public_path__ + "static/media/regtech.43ab1b97.png";